import { Button, Modal } from 'antd';
import React, { useState,useEffect, useRef, useLayoutEffect } from 'react';
import './index.less';
import Camix from '@/resource/icon-gif/Camix.gif';
import Dovetail from '@/resource/icon-gif/Dovetail.gif';
import Fusilade_Max from '@/resource/icon-gif/Fusilade_Max.gif';
import NK from '@/resource/icon-gif/NK-logo.gif';
import Peak from '@/resource/icon-gif/Peak.gif';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@reduxjs/toolkit';
import IF from '@/components/IF';
import {agriAlertGetCropsSpray,agriAlertGetForecastData,
    agriAlertGetForecastHourlyData,agriAlertGetHistoricalData,
    agriAlertGetHistoricalOrForecastData, getAgriAlertTranslateValue} from '@/util/Request/agrialert/index';
import { IAgriAlertTranslateModel, IAgriAlertTranslateResModel, IGetCorpsSprayResModel , IGetHistoricalOrForecastDataResModel} from '@/util/Request/agrialert/responseType';
import moment from 'moment';
import { updateTranslateData } from '@/redux/reducer/agrialertTemplate';
import {sprayOptions} from './initData';
import { AgriAlertClearIcon, AgriAlertClearIconWhite } from '@/resource/IconComponentSets';
import Item from 'antd/lib/list/Item';
import { AgronomicTypeEnum, TimePeriodEnum } from '../template-edit/components/agronomicRecommendations/initTypeAndFunc';
import { IGetCorpsSprayReqModel, IGetDiseaseRiskReqModel, IGetPhytophagyStressReqModel, IGetPlantingReqModel, IGetStressAlertReqModel } from '@/util/Request/agrialert/requestType';
// Self define component
import TemplatePlanting from './components/template-planting';
import TemplateDisease from './components/template-disease';
import TemplateStress from './components/template-stress';
import TemplatePreviewChart from './components/template-preview-chart';
import TemplateSpray from './components/template-spray';
import TemplateHeatStressRisk from './components/template-phytopphagy';
import TemplateColdStressRisk from './components/template-phytopphagy';
import TemplateHistoricalChart from './components/template-historicalChart';
// import TemplateForecastCharts from './components/template-forecast';
import TemplateForecastTables from './components/template-forecast';
import { ChartsOrTablesEnum, HeatOrColdStressRiskEnum } from '../../template-management';

interface IProps {
    modalOpen:boolean;
    title:string;
    changeModalOpenCallback?: ()=>void
    editableFooterContent:string;
}



const TemplatePreview = (prop:IProps)=>{
    const {
        modalOpen,
        title,
        changeModalOpenCallback,
        editableFooterContent
    } = prop;

    const dispatch = useDispatch();
    const previewDetails = useSelector((state: RootState) => state.agrialertTemplate.previewDetails);
    const allBannerList = useSelector((state: RootState) => state.agrialertTemplate.allBananer);
    const fileContent = useSelector((state: RootState) => state.agrialertTemplate.fileContent);
    const translateData = useSelector((state: RootState) => state.agrialertTemplate.translateData);


    const [historicalData,setHistoricalData] = useState<IGetHistoricalOrForecastDataResModel[]>(null);
    // const [forecastData,setForecastData] = useState<IGetHistoricalOrForecastDataResModel[]>(null);
    const [forecastChartData,setForecastChartData] = useState<IGetHistoricalOrForecastDataResModel[]>(null);
    const [forecastTableDailyData,setForecastTableDailyData] = useState<IGetHistoricalOrForecastDataResModel[]>(null);
    const [forecastTableHourlyData,setForecastTableHourlyData] = useState<IGetHistoricalOrForecastDataResModel[]>(null);
    const [allBannerUrl,setAllBannerUrl] = useState<string[]>([]);
    const [finalTranslateData,setFinalTranslateData] = useState<IAgriAlertTranslateResModel>(null);


    const [localImageList,setLocalImageList] = useState<any[]>([]);
    useEffect(()=>{
        if(modalOpen && fileContent?.length >= 1){
            const tmpLocalImageList = [...localImageList];
            fileContent?.forEach((item,index)=>{
                const file = item.fileContent?.[0];
                if(file){
                    const reader = new FileReader();
                    // when reader sepcial file content finished, will invoke this funciton
                    reader.onload = (e)=>{
                        tmpLocalImageList.push(e?.target?.result);
                    };
                    // start reader special file content
                    reader.readAsDataURL(file);
                }
            });
            setLocalImageList(tmpLocalImageList);
        }
    },[modalOpen,fileContent]);


    // get historical data
    const getHistoricalDataFunc = async(translateData:IAgriAlertTranslateResModel)=>{
        try{
            const res = await agriAlertGetHistoricalData({
                requestVariables: previewDetails?.historicalVariables?.join(';'),
                // requestVariables: 'precipitation;soil_temperature;temperature_daily_min;relative_humidity;temperature_daily_average;wind_speed;soil_moilsture;wind_gust;temperature_daily_max',
                lat: previewDetails?.templateLat,
                lng: previewDetails?.templateLng,
                startDate: null,
                aggration: previewDetails?.historicalAggregation,
                requestDays: previewDetails?.historicalDays,
                languageCode: previewDetails?.languageCode,
                unit: previewDetails?.reportUnit || 'metric'
            });
            const tmpData = res.data;
            tmpData.forEach((item,index)=>{
                // change week name
                item?.weeks?.forEach((innerItem,innerIndex)=>{
                    innerItem.weekName = getWeekTranslate(translateData,innerItem?.weekIndex);
                });
                if(item.unit === 'C'){
                    item.unit = '°C';
                }
                // change series name
                if(item.variable === 'Temperature' && item.aggregation === 'min'){
                    // item.variable = 'Temperature Min';
                    item.variable = translateData?.temperature_daily_min;
                }
                if(item.variable === 'Temperature' && item.aggregation === 'max'){
                    // item.variable = 'Temperature Max';
                    item.variable = translateData?.temperature_daily_max;
                }
                if(item.variable === 'Temperature' && item.aggregation === 'mean'){
                    // item.variable = 'Temperature Average';
                    item.variable = translateData?.temperature_daily_average;
                }
                if(item.code === 61){
                    item.variable = translateData?.precipitation;
                }
                if(item.code === 52){
                    item.variable = translateData?.relative_humidity;
                }
                if(item.code === 32){
                    item.variable = translateData?.wind_speed;
                }
                if(item.code === 85){
                    item.variable = translateData?.soil_temperature;
                }
                if(item.code === 144){
                    item.variable = translateData?.soil_moilsture;
                }
                if(item.code === 180){
                    item.variable = translateData?.wind_gust;
                }
                // new variables for forecast and historical
                if(item.code === 71){
                    item.variable = translateData?.cloud_cover;
                }
                if(item.code === 31){
                    item.variable = translateData?.wind_direction;
                }
                if(item.code === 204){
                    item.variable = translateData?.radiation;
                }
                if(item.code === 17){
                    item.variable = translateData?.dewpoint;
                }
                if(item.code === 1){
                    item.variable = translateData?.air_pressure;
                }
                if(item.code === 730){
                    item.variable = translateData?.growing_degree_days;
                }
                if(item.code === 2){
                    item.variable = translateData?.precipitation_risk;
                }
                if(item.code === 3){
                    item.variable = translateData?.shower_risk;
                }
                if(item.code === 4){
                    item.variable = translateData?.thunderstorm_risk;
                }
            });
            setHistoricalData(tmpData);
            console.log('historical data: ',res.data);
        }
        catch(error){
            console.log('get historical data failed, error is ',error);
        }
    };



    // get Forecast daily data, for chart and table


    // get all Banner From s3
    const getAllBannerFromS3 = ()=>{
        const tmpAllBannerUrl = [];
        previewDetails?.templateBannerList?.forEach((item)=>{
            const tmpBanner = allBannerList.filter( x => x.bannerS3Name === item)?.[0];
            if(tmpBanner?.bannerS3URL){
                tmpAllBannerUrl.push(tmpBanner?.bannerS3URL);
            }
        });
        setAllBannerUrl(tmpAllBannerUrl);
    };

    // get translate value
    const checkWhetherGetTranslateFromApi = async()=>{
        console.log('lanxue translage get');
        const tmpData = translateData.filter( x => x.languageCode === previewDetails?.languageCode);
        if(tmpData?.length >= 1){
            // mean current data exist
            console.log('current data is already exist');
            return tmpData[0].translateValues;
        }
        else{
            console.log('lanxue previewdata',previewDetails);
            const result = await getAgriAlertTranslateValue(previewDetails?.languageCode || 'en');
            console.log('lanxue translate result',result);
            const tmpTranslateData = [...translateData];
            tmpTranslateData.push({
                languageCode: previewDetails?.languageCode,
                translateValues: result
            });
            dispatch(updateTranslateData(tmpTranslateData));
            return result;
        }
    };


    const getWeekTranslate = (translateData: IAgriAlertTranslateResModel,index:number)=>{
        let tmpWeekName = '';
        switch(index){
            case 0:
                tmpWeekName = translateData?.sun;
                break;
            case 1:
                tmpWeekName = translateData?.mon;
                break;
            case 2:
                tmpWeekName = translateData?.tue;
                break;
            case 3:
                tmpWeekName = translateData?.wed;
                break;
            case 4:
                tmpWeekName = translateData?.thu;
                break;
            case 5:
                tmpWeekName = translateData?.fri;
                break;
            case 6:
                tmpWeekName = translateData?.sat;
                break;
        }
        return tmpWeekName;
    };
    useEffect(()=>{
        if(translateData?.length >= 1 && modalOpen){
            const tmpValue = translateData?.filter( x => x.languageCode === previewDetails?.languageCode)?.[0];
            if(tmpValue){
                const tmpTranslateData = {...tmpValue.translateValues};
                setFinalTranslateData(tmpTranslateData);
            }
        }
    },[translateData]);

    // check whether show compent for agronomic
    const initAgronomic = ()=>{
        try{
            // for Planting
            const tmpAllForecastPlanting = previewDetails?.agronomic?.filter(x =>
                x?.isMixedForecastHistorical !== true &&
                x.isHistorical === false && x.planting);
            const tmpAllHistoricalPlanting = previewDetails?.agronomic?.filter(x =>
                x?.isMixedForecastHistorical !== true &&
                x.isHistorical === true && x.planting);
            const tmpAllMixedPlanting = previewDetails?.agronomic?.filter(x => x.isMixedForecastHistorical === true && x.planting);
            const tmpAllPlantingReq:IGetPlantingReqModel[] = [];
            if(tmpAllForecastPlanting?.length >= 1){
                // let tmpForecastCrop = '';
                tmpAllForecastPlanting?.forEach((item)=>{
                    const tmpForecastDays = item?.forecastDays ? item?.forecastDays -1 : 6;
                    const tmpStartDate = moment().format('yyyy-MM-DD');
                    const tmpEndDate = moment().add(tmpForecastDays,'day').format('yyyy-MM-DD');
                    tmpAllPlantingReq.push({
                        lat: previewDetails?.templateLat,
                        lng: previewDetails?.templateLng,
                        startDate: tmpStartDate,
                        cropType: item?.planting,
                        endDate: tmpEndDate,
                        languageCode: previewDetails?.languageCode,
                        groupId: tmpStartDate + '-' + tmpEndDate
                    });
                });

            }
            if(tmpAllHistoricalPlanting?.length >=1 ){
                tmpAllHistoricalPlanting?.forEach((item)=>{
                    let tmpStartDate = '';
                    let tmpEndDate = '';
                    let tmpGroupId = '';
                    if(item?.historicalSetting?.timePeriod === TimePeriodEnum.SEVEN){
                        tmpStartDate = moment().add(-7,'day').format('yyyy-MM-DD');
                        tmpEndDate = moment().add(-1,'day').format('yyyy-MM-DD');
                        tmpGroupId = tmpStartDate + '-' + tmpEndDate;
                    }
                    else if(item?.historicalSetting?.timePeriod === TimePeriodEnum.FOURTEEN){
                        tmpStartDate = moment().add(-14,'day').format('yyyy-MM-DD');
                        tmpEndDate = moment().add(-1,'day').format('yyyy-MM-DD');
                        tmpGroupId = tmpStartDate + '-' + tmpEndDate;
                    }
                    else if(item?.historicalSetting?.timePeriod === TimePeriodEnum.CUSTOM){
                        tmpStartDate = item?.historicalSetting.startDate;
                        tmpEndDate = item?.historicalSetting.endDate;
                        tmpGroupId = item?.historicalSetting.startDate + '-' + item?.historicalSetting.endDate;
                    }
                    tmpAllPlantingReq.push({
                        lat: previewDetails?.templateLat,
                        lng: previewDetails?.templateLng,
                        cropType: item?.planting,
                        startDate: tmpStartDate,
                        endDate: tmpEndDate,
                        languageCode: previewDetails?.languageCode,
                        groupId: tmpGroupId
                    });
                });
            }
            if(tmpAllMixedPlanting?.length >= 1){
                // let tmpForecastCrop = '';
                tmpAllMixedPlanting?.forEach((item)=>{
                    // for forecast
                    const tmpForecastDays = item?.forecastDays ? item?.forecastDays -1 : 6;
                    const tmpForecastStartDate = moment().format('yyyy-MM-DD');
                    const tmpForecastEndDate = moment().add(tmpForecastDays,'day').format('yyyy-MM-DD');
                    tmpAllPlantingReq.push({
                        lat: previewDetails?.templateLat,
                        lng: previewDetails?.templateLng,
                        startDate: tmpForecastStartDate,
                        cropType: item?.planting,
                        endDate: tmpForecastEndDate,
                        languageCode: previewDetails?.languageCode,
                        groupIdForMixed: (item?.historicalDays || 7) + '-' + (item?.forecastDays || 7) + '-' + item?.planting,
                        groupId: tmpForecastStartDate + '-' + tmpForecastEndDate
                    });
                    // for historical
                    const tmpHistoricalDays = item?.historicalDays || 7;
                    const tmpHistoricalStartDate = moment().add(-tmpHistoricalDays,'day').format('yyyy-MM-DD');
                    const tmpHistoricalEndDate = moment().add(-1,'day').format('yyyy-MM-DD');
                    tmpAllPlantingReq.push({
                        lat: previewDetails?.templateLat,
                        lng: previewDetails?.templateLng,
                        startDate: tmpHistoricalStartDate,
                        cropType: item?.planting,
                        endDate: tmpHistoricalEndDate,
                        languageCode: previewDetails?.languageCode,
                        groupIdForMixed: (item?.historicalDays || 7) + '-' + (item?.forecastDays || 7) + '-' + item?.planting,
                        groupId: tmpHistoricalStartDate + '-' + tmpHistoricalEndDate
                    });
                });

            }

            if(tmpAllPlantingReq?.length >= 1){
                setAllPlantingReq(tmpAllPlantingReq);
                setShowPlanting(true);
            }

            // for Disease Risk
            const tmpAllForecastDiseaseRisk = previewDetails?.agronomic?.filter(
                x => x?.isMixedForecastHistorical !== true &&
                    x?.isHistorical === false && x?.disease?.modelID);
            const tmpAllHistoricalDiseaseRisk = previewDetails?.agronomic?.filter(
                x => x?.isMixedForecastHistorical !== true &&
                    x?.isHistorical === true && x?.disease?.modelID);
            const tmpAllMixedDiseaseRisk = previewDetails?.agronomic?.filter(
                x => x.isMixedForecastHistorical === true && x?.disease?.modelID);
            const tmpAllDiseaseRiskReq:IGetDiseaseRiskReqModel[] = [];
            if(tmpAllForecastDiseaseRisk?.length >= 1){
                // let tmpForecastCrop = '';
                tmpAllForecastDiseaseRisk?.forEach((item)=>{
                    const tmpForecastDays = item?.forecastDays ? item?.forecastDays -1 : 6;
                    const tmpStartDate = moment().format('yyyy-MM-DD');
                    const tmpEndDate = moment().add(tmpForecastDays,'day').format('yyyy-MM-DD');
                    tmpAllDiseaseRiskReq.push({
                        lat: previewDetails?.templateLat,
                        lng: previewDetails?.templateLng,
                        startDate: tmpStartDate,
                        diseaseRisk: item?.disease?.modelID,
                        endDate: tmpEndDate,
                        languageCode: previewDetails?.languageCode,
                        groupId: tmpStartDate + '-' + tmpEndDate
                    });
                    // tmpForecastCrop = tmpForecastCrop + item?.disease?.modelID + ';';
                });

            }
            if(tmpAllHistoricalDiseaseRisk?.length >=1 ){
                tmpAllHistoricalDiseaseRisk?.forEach((item)=>{
                    let tmpStartDate = '';
                    let tmpEndDate = '';
                    let tmpGroupId = '';
                    if(item?.historicalSetting?.timePeriod === TimePeriodEnum.SEVEN){
                        tmpStartDate = moment().add(-7,'day').format('yyyy-MM-DD');
                        tmpEndDate = moment().add(-1,'day').format('yyyy-MM-DD');
                        tmpGroupId = tmpStartDate + '-' + tmpEndDate;
                    }
                    else if(item?.historicalSetting?.timePeriod === TimePeriodEnum.FOURTEEN){
                        tmpStartDate = moment().add(-14,'day').format('yyyy-MM-DD');
                        tmpEndDate = moment().add(-1,'day').format('yyyy-MM-DD');
                        tmpGroupId = tmpStartDate + '-' + tmpEndDate;
                    }
                    else if(item?.historicalSetting?.timePeriod === TimePeriodEnum.CUSTOM){
                        tmpStartDate = item?.historicalSetting.startDate;
                        tmpEndDate = item?.historicalSetting.endDate;
                        tmpGroupId = item?.historicalSetting.startDate + '-' + item?.historicalSetting.endDate;
                    }
                    tmpAllDiseaseRiskReq.push({
                        lat: previewDetails?.templateLat,
                        lng: previewDetails?.templateLng,
                        diseaseRisk: item?.disease?.modelID,
                        startDate: tmpStartDate,
                        endDate: tmpEndDate,
                        languageCode: previewDetails?.languageCode,
                        groupId: tmpGroupId
                    });
                });

            }
            if(tmpAllMixedDiseaseRisk?.length >= 1){
                // let tmpForecastCrop = '';
                tmpAllMixedDiseaseRisk?.forEach((item)=>{
                    // for forecast
                    const tmpForecastDays = item?.forecastDays ? item?.forecastDays -1 : 6;
                    const tmpForecastStartDate = moment().format('yyyy-MM-DD');
                    const tmpForecastEndDate = moment().add(tmpForecastDays,'day').format('yyyy-MM-DD');
                    tmpAllDiseaseRiskReq.push({
                        lat: previewDetails?.templateLat,
                        lng: previewDetails?.templateLng,
                        startDate: tmpForecastStartDate,
                        diseaseRisk: item?.disease?.modelID,
                        endDate: tmpForecastEndDate,
                        languageCode: previewDetails?.languageCode,
                        groupIdForMixed: (item?.historicalDays || 7) + '-' + (item?.forecastDays || 7) + '-' + item?.disease?.modelID,
                        groupId: tmpForecastStartDate + '-' + tmpForecastEndDate
                    });
                    // for historical
                    const tmpHistoricalDays = item?.historicalDays || 7;
                    const tmpHistoricalStartDate = moment().add(-tmpHistoricalDays,'day').format('yyyy-MM-DD');
                    const tmpHistoricalEndDate = moment().add(-1,'day').format('yyyy-MM-DD');
                    tmpAllDiseaseRiskReq.push({
                        lat: previewDetails?.templateLat,
                        lng: previewDetails?.templateLng,
                        startDate: tmpHistoricalStartDate,
                        diseaseRisk: item?.disease?.modelID,
                        endDate: tmpHistoricalEndDate,
                        languageCode: previewDetails?.languageCode,
                        groupIdForMixed: (item?.historicalDays || 7) + '-' + (item?.forecastDays || 7) + '-' + item?.disease?.modelID,
                        groupId: tmpHistoricalStartDate + '-' + tmpHistoricalEndDate
                    });
                });

            }
            if(tmpAllDiseaseRiskReq?.length >= 1){
                setAllDiseaseRiskReq(tmpAllDiseaseRiskReq);
                setShowDisease(true);
            }

            // for Stress Alert
            const tmpAllForecastStressAlert = previewDetails?.agronomic?.filter(
                x => x.isMixedForecastHistorical !== true &&
                    x.isHistorical === false && x?.stress);
            const tmpAllHistoricalStressAlert = previewDetails?.agronomic?.filter(
                x => x.isMixedForecastHistorical !== true &&
                x.isHistorical === true && x?.stress);
            const tmpAllMixedStressAlert = previewDetails?.agronomic?.filter(
                x => x.isMixedForecastHistorical === true && x?.stress);
            const tmpAllStressAlertReq:IGetStressAlertReqModel[] = [];
            if(tmpAllForecastStressAlert?.length >= 1){
                // let tmpForecastCrop = '';
                tmpAllForecastStressAlert?.forEach((item)=>{
                    const tmpForecastDays = item?.forecastDays ? item?.forecastDays -1 : 6;
                    const tmpStartDate = moment().format('yyyy-MM-DD');
                    const tmpEndDate = moment().add(tmpForecastDays,'day').format('yyyy-MM-DD');
                    tmpAllStressAlertReq.push({
                        lat: previewDetails?.templateLat,
                        lng: previewDetails?.templateLng,
                        startDate: tmpStartDate,
                        stressAlertType: item?.stress,
                        endDate: tmpEndDate,
                        languageCode: previewDetails?.languageCode,
                        groupId: tmpStartDate + '-' + tmpEndDate
                    });
                });

            }
            if(tmpAllHistoricalStressAlert?.length >=1 ){
                tmpAllHistoricalStressAlert?.forEach((item)=>{
                    let tmpStartDate = '';
                    let tmpEndDate = '';
                    let tmpGroupId = '';
                    if(item?.historicalSetting?.timePeriod === TimePeriodEnum.SEVEN){
                        tmpStartDate = moment().add(-7,'day').format('yyyy-MM-DD');
                        tmpEndDate = moment().add(-1,'day').format('yyyy-MM-DD');
                        tmpGroupId = tmpStartDate + '-' + tmpEndDate;
                    }
                    else if(item?.historicalSetting?.timePeriod === TimePeriodEnum.FOURTEEN){
                        tmpStartDate = moment().add(-14,'day').format('yyyy-MM-DD');
                        tmpEndDate = moment().add(-1,'day').format('yyyy-MM-DD');
                        tmpGroupId = tmpStartDate + '-' + tmpEndDate;
                    }
                    else if(item?.historicalSetting?.timePeriod === TimePeriodEnum.CUSTOM){
                        tmpStartDate = item?.historicalSetting.startDate;
                        tmpEndDate = item?.historicalSetting.endDate;
                        tmpGroupId = item?.historicalSetting.startDate + '-' + item?.historicalSetting.endDate;
                    }
                    tmpAllStressAlertReq.push({
                        lat: previewDetails?.templateLat,
                        lng: previewDetails?.templateLng,
                        stressAlertType: item?.stress,
                        startDate: tmpStartDate,
                        endDate: tmpEndDate,
                        languageCode: previewDetails?.languageCode,
                        groupId: tmpGroupId
                    });
                });
            }
            if(tmpAllMixedStressAlert?.length >= 1){
                // let tmpForecastCrop = '';
                tmpAllMixedStressAlert?.forEach((item)=>{
                    // for forecast
                    const tmpForecastDays = item?.forecastDays ? item?.forecastDays -1 : 6;
                    const tmpForecastStartDate = moment().format('yyyy-MM-DD');
                    const tmpForecastEndDate = moment().add(tmpForecastDays,'day').format('yyyy-MM-DD');
                    tmpAllStressAlertReq.push({
                        lat: previewDetails?.templateLat,
                        lng: previewDetails?.templateLng,
                        startDate: tmpForecastStartDate,
                        stressAlertType: item?.stress,
                        endDate: tmpForecastEndDate,
                        languageCode: previewDetails?.languageCode,
                        groupIdForMixed: (item?.historicalDays || 7) + '-' + (item?.forecastDays || 7) + '-' + item?.stress,
                        groupId: tmpForecastStartDate + '-' + tmpForecastEndDate
                    });
                    // for historical
                    const tmpHistoricalDays = item?.historicalDays || 7;
                    const tmpHistoricalStartDate = moment().add(-tmpHistoricalDays,'day').format('yyyy-MM-DD');
                    const tmpHistoricalEndDate = moment().add(-1,'day').format('yyyy-MM-DD');
                    tmpAllStressAlertReq.push({
                        lat: previewDetails?.templateLat,
                        lng: previewDetails?.templateLng,
                        startDate: tmpHistoricalStartDate,
                        stressAlertType: item?.stress,
                        endDate: tmpHistoricalEndDate,
                        languageCode: previewDetails?.languageCode,
                        groupIdForMixed: (item?.historicalDays || 7) + '-' + (item?.forecastDays || 7) + '-' + item?.stress,
                        groupId: tmpHistoricalStartDate + '-' + tmpHistoricalEndDate
                    });
                });

            }
            if(tmpAllStressAlertReq?.length >= 1){
                setAllStressAlertReq(tmpAllStressAlertReq);
                setShowStressAlert(true);
            }



            // for Spray
            const tmpAllForecastSprayAlert = previewDetails?.agronomic?.filter(
                x => x?.isMixedForecastHistorical !== true &&
                    x.isHistorical === false && x?.spray);
            const tmpAllHistoricalSpray = previewDetails?.agronomic?.filter(
                x =>x?.isMixedForecastHistorical !== true &&
                    x.isHistorical === true && x?.spray);
            const tmpAllMixedSpray = previewDetails?.agronomic?.filter(
                x =>x?.isMixedForecastHistorical === true && x?.spray);
            const tmpAllSprayReq:IGetCorpsSprayReqModel[] = [];
            if(tmpAllForecastSprayAlert?.length >= 1){
                // let tmpForecastCrop = '';
                tmpAllForecastSprayAlert?.forEach((item)=>{
                    const tmpForecastDays = item?.forecastDays ? item?.forecastDays -1 : 6;
                    const tmpStartDate = moment().format('yyyy-MM-DD');
                    const tmpEndDate = moment().add(tmpForecastDays,'day').format('yyyy-MM-DD');
                    tmpAllSprayReq.push({
                        latitude: previewDetails?.templateLat,
                        longitude: previewDetails?.templateLng,
                        startDate: tmpStartDate,
                        sprayingType: item?.spray,
                        endDate: tmpEndDate,
                        languageCode: previewDetails?.languageCode,
                        groupId: tmpStartDate + '-' + tmpEndDate
                    });
                });

            }
            if(tmpAllHistoricalSpray?.length >=1 ){
                tmpAllHistoricalSpray?.forEach((item)=>{
                    let tmpStartDate = '';
                    let tmpEndDate = '';
                    let tmpGroupId = '';
                    if(item?.historicalSetting?.timePeriod === TimePeriodEnum.SEVEN){
                        tmpStartDate = moment().add(-7,'day').format('yyyy-MM-DD');
                        tmpEndDate = moment().add(-1,'day').format('yyyy-MM-DD');
                        tmpGroupId = tmpStartDate + '-' + tmpEndDate;
                    }
                    else if(item?.historicalSetting?.timePeriod === TimePeriodEnum.FOURTEEN){
                        tmpStartDate = moment().add(-14,'day').format('yyyy-MM-DD');
                        tmpEndDate = moment().add(-1,'day').format('yyyy-MM-DD');
                        tmpGroupId = tmpStartDate + '-' + tmpEndDate;
                    }
                    else if(item?.historicalSetting?.timePeriod === TimePeriodEnum.CUSTOM){
                        tmpStartDate = item?.historicalSetting.startDate;
                        tmpEndDate = item?.historicalSetting.endDate;
                        tmpGroupId = item?.historicalSetting.startDate + '-' + item?.historicalSetting.endDate;
                    }
                    tmpAllSprayReq.push({
                        latitude: previewDetails?.templateLat,
                        longitude: previewDetails?.templateLng,
                        sprayingType: item?.spray,
                        startDate: tmpStartDate,
                        endDate: tmpEndDate,
                        languageCode: previewDetails?.languageCode,
                        groupId: tmpGroupId
                    });
                });

            }
            if(tmpAllMixedSpray?.length >= 1){
                // let tmpForecastCrop = '';
                tmpAllMixedSpray?.forEach((item)=>{
                    // for forecast
                    const tmpForecastDays = item?.forecastDays ? item?.forecastDays -1 : 6;
                    const tmpForecastStartDate = moment().format('yyyy-MM-DD');
                    const tmpForecastEndDate = moment().add(tmpForecastDays,'day').format('yyyy-MM-DD');
                    tmpAllSprayReq.push({
                        latitude: previewDetails?.templateLat,
                        longitude: previewDetails?.templateLng,
                        startDate: tmpForecastStartDate,
                        sprayingType: item?.spray,
                        endDate: tmpForecastEndDate,
                        languageCode: previewDetails?.languageCode,
                        groupIdForMixed: (item?.historicalDays || 7) + '-' + (item?.forecastDays || 7) + '-' + item?.spray,
                        groupId: tmpForecastStartDate + '-' + tmpForecastEndDate
                    });
                    // for historical
                    const tmpHistoricalDays = item?.historicalDays || 7;
                    const tmpHistoricalStartDate = moment().add(-tmpHistoricalDays,'day').format('yyyy-MM-DD');
                    const tmpHistoricalEndDate = moment().add(-1,'day').format('yyyy-MM-DD');
                    tmpAllSprayReq.push({
                        latitude: previewDetails?.templateLat,
                        longitude: previewDetails?.templateLng,
                        startDate: tmpHistoricalStartDate,
                        sprayingType: item?.spray,
                        endDate: tmpHistoricalEndDate,
                        languageCode: previewDetails?.languageCode,
                        groupIdForMixed: (item?.historicalDays || 7) + '-' + (item?.forecastDays || 7) + '-' + item?.spray,
                        groupId: tmpHistoricalStartDate + '-' + tmpHistoricalEndDate
                    });
                });

            }
            if(tmpAllSprayReq?.length >= 1){
                setAllSprayReq(tmpAllSprayReq);
                setShowSpray(true);
            }


            // for Heat Stress Risk
            // TODO: need
            const tmpAllForecastHeatStressRisk = previewDetails?.agronomic?.filter(
                x =>x?.isMixedForecastHistorical !== true &&
                    x.isHistorical === false && x?.agronomicType === AgronomicTypeEnum.HEATSTRESSRISK &&
                  x?.heatStressRisk);
            const tmpAllHistoricalHeatStressRisk = previewDetails?.agronomic?.filter(
                x =>x?.isMixedForecastHistorical !== true &&
                    x.isHistorical === true && x?.agronomicType === AgronomicTypeEnum.HEATSTRESSRISK &&
                x?.heatStressRisk);
            const tmpAllMixedHeatStressRisk = previewDetails?.agronomic?.filter(
                x =>x?.isMixedForecastHistorical === true && x?.agronomicType === AgronomicTypeEnum.HEATSTRESSRISK &&
                x?.heatStressRisk);
            const tmpAllHeatStressRiskReq:IGetPhytophagyStressReqModel[] = [];
            if(tmpAllForecastHeatStressRisk?.length >= 1){
                tmpAllForecastHeatStressRisk?.forEach((item)=>{
                    const tmpForecastDays = item?.forecastDays ? item?.forecastDays -1 : 6;
                    const tmpStartDate = moment().format('yyyy-MM-DD');
                    const tmpEndDate = moment().add(tmpForecastDays,'day').format('yyyy-MM-DD');
                    tmpAllHeatStressRiskReq.push({
                        lat: previewDetails?.templateLat,
                        lng: previewDetails?.templateLng,
                        startDate: tmpStartDate,
                        cropType:  item?.heatStressRisk,
                        endDate: tmpEndDate,
                        languageCode: previewDetails?.languageCode,
                        groupId: tmpStartDate + '-' + tmpEndDate
                    });
                });

            }
            if(tmpAllHistoricalHeatStressRisk?.length >=1 ){
                tmpAllHistoricalHeatStressRisk?.forEach((item)=>{
                    let tmpStartDate = '';
                    let tmpEndDate = '';
                    let tmpGroupId = '';
                    if(item?.historicalSetting?.timePeriod === TimePeriodEnum.SEVEN){
                        tmpStartDate = moment().add(-7,'day').format('yyyy-MM-DD');
                        tmpEndDate = moment().add(-1,'day').format('yyyy-MM-DD');
                        tmpGroupId = tmpStartDate + '-' + tmpEndDate;
                    }
                    else if(item?.historicalSetting?.timePeriod === TimePeriodEnum.FOURTEEN){
                        tmpStartDate = moment().add(-14,'day').format('yyyy-MM-DD');
                        tmpEndDate = moment().add(-1,'day').format('yyyy-MM-DD');
                        tmpGroupId = tmpStartDate + '-' + tmpEndDate;
                    }
                    else if(item?.historicalSetting?.timePeriod === TimePeriodEnum.CUSTOM){
                        tmpStartDate = item?.historicalSetting.startDate;
                        tmpEndDate = item?.historicalSetting.endDate;
                        tmpGroupId = item?.historicalSetting.startDate + '-' + item?.historicalSetting.endDate;
                    }
                    tmpAllHeatStressRiskReq.push({
                        lat: previewDetails?.templateLat,
                        lng: previewDetails?.templateLng,
                        cropType: item?.heatStressRisk,
                        startDate: tmpStartDate,
                        endDate: tmpEndDate,
                        languageCode: previewDetails?.languageCode,
                        groupId: tmpGroupId
                    });
                });

            }
            if(tmpAllMixedHeatStressRisk?.length >= 1){
                // let tmpForecastCrop = '';
                tmpAllMixedHeatStressRisk?.forEach((item)=>{
                    // for forecast
                    const tmpForecastDays = item?.forecastDays ? item?.forecastDays -1 : 6;
                    const tmpForecastStartDate = moment().format('yyyy-MM-DD');
                    const tmpForecastEndDate = moment().add(tmpForecastDays,'day').format('yyyy-MM-DD');
                    tmpAllHeatStressRiskReq.push({
                        lat: previewDetails?.templateLat,
                        lng: previewDetails?.templateLng,
                        startDate: tmpForecastStartDate,
                        cropType: item?.heatStressRisk,
                        endDate: tmpForecastEndDate,
                        languageCode: previewDetails?.languageCode,
                        groupIdForMixed: (item?.historicalDays || 7) + '-' + (item?.forecastDays || 7) + '-' + item?.heatStressRisk,
                        groupId: tmpForecastStartDate + '-' + tmpForecastEndDate
                    });
                    // for historical
                    const tmpHistoricalDays = item?.historicalDays || 7;
                    const tmpHistoricalStartDate = moment().add(-tmpHistoricalDays,'day').format('yyyy-MM-DD');
                    const tmpHistoricalEndDate = moment().add(-1,'day').format('yyyy-MM-DD');
                    tmpAllHeatStressRiskReq.push({
                        lat: previewDetails?.templateLat,
                        lng: previewDetails?.templateLng,
                        startDate: tmpHistoricalStartDate,
                        cropType: item?.heatStressRisk,
                        endDate: tmpHistoricalEndDate,
                        languageCode: previewDetails?.languageCode,
                        groupIdForMixed: (item?.historicalDays || 7) + '-' + (item?.forecastDays || 7) + '-' + item?.heatStressRisk,
                        groupId: tmpHistoricalStartDate + '-' + tmpHistoricalEndDate
                    });
                });

            }
            if(tmpAllHeatStressRiskReq?.length >= 1){
                setAllHeatStressRiskReq(tmpAllHeatStressRiskReq);
                setShowHeatStressRisk(true);
            }

            // for Cold Stress Risk
            const tmpAllForecastColdStressRisk = previewDetails?.agronomic?.filter(
                x =>x?.isMixedForecastHistorical !== true &&
                    x.isHistorical === false && x?.agronomicType === AgronomicTypeEnum.COLDSTRESSRISK &&
                  x?.coldStressRisk);
            const tmpAllHistoricalColdStressRisk = previewDetails?.agronomic?.filter(
                x =>x?.isMixedForecastHistorical !== true &&
                    x.isHistorical === true && x?.agronomicType === AgronomicTypeEnum.COLDSTRESSRISK &&
                x?.coldStressRisk);
            const tmpAllMixedColdStressRisk = previewDetails?.agronomic?.filter(
                x =>x?.isMixedForecastHistorical === true && x?.agronomicType === AgronomicTypeEnum.COLDSTRESSRISK &&
                x?.coldStressRisk);
            const tmpAllColdStressRiskReq:IGetPhytophagyStressReqModel[] = [];
            if(tmpAllForecastColdStressRisk?.length >= 1){
                tmpAllForecastColdStressRisk?.forEach((item)=>{
                    const tmpForecastDays = item?.forecastDays ? item?.forecastDays -1 : 6;
                    const tmpStartDate = moment().format('yyyy-MM-DD');
                    const tmpEndDate = moment().add(tmpForecastDays,'day').format('yyyy-MM-DD');
                    tmpAllColdStressRiskReq.push({
                        lat: previewDetails?.templateLat,
                        lng: previewDetails?.templateLng,
                        startDate: tmpStartDate,
                        cropType:  item?.coldStressRisk,
                        endDate: tmpEndDate,
                        languageCode: previewDetails?.languageCode,
                        groupId: tmpStartDate + '-' + tmpEndDate
                    });
                });

            }
            if(tmpAllHistoricalColdStressRisk?.length >=1 ){
                tmpAllHistoricalColdStressRisk?.forEach((item)=>{
                    let tmpStartDate = '';
                    let tmpEndDate = '';
                    let tmpGroupId = '';
                    if(item?.historicalSetting?.timePeriod === TimePeriodEnum.SEVEN){
                        tmpStartDate = moment().add(-7,'day').format('yyyy-MM-DD');
                        tmpEndDate = moment().add(-1,'day').format('yyyy-MM-DD');
                        tmpGroupId = tmpStartDate + '-' + tmpEndDate;
                    }
                    else if(item?.historicalSetting?.timePeriod === TimePeriodEnum.FOURTEEN){
                        tmpStartDate = moment().add(-14,'day').format('yyyy-MM-DD');
                        tmpEndDate = moment().add(-1,'day').format('yyyy-MM-DD');
                        tmpGroupId = tmpStartDate + '-' + tmpEndDate;
                    }
                    else if(item?.historicalSetting?.timePeriod === TimePeriodEnum.CUSTOM){
                        tmpStartDate = item?.historicalSetting.startDate;
                        tmpEndDate = item?.historicalSetting.endDate;
                        tmpGroupId = item?.historicalSetting.startDate + '-' + item?.historicalSetting.endDate;
                    }
                    tmpAllColdStressRiskReq.push({
                        lat: previewDetails?.templateLat,
                        lng: previewDetails?.templateLng,
                        cropType: item?.coldStressRisk,
                        startDate: tmpStartDate,
                        endDate: tmpEndDate,
                        languageCode: previewDetails?.languageCode,
                        groupId: tmpGroupId
                    });
                });

            }
            if(tmpAllMixedColdStressRisk?.length >= 1){
                // let tmpForecastCrop = '';
                tmpAllMixedColdStressRisk?.forEach((item)=>{
                    // for forecast
                    const tmpForecastDays = item?.forecastDays ? item?.forecastDays -1 : 6;
                    const tmpForecastStartDate = moment().format('yyyy-MM-DD');
                    const tmpForecastEndDate = moment().add(tmpForecastDays,'day').format('yyyy-MM-DD');
                    tmpAllColdStressRiskReq.push({
                        lat: previewDetails?.templateLat,
                        lng: previewDetails?.templateLng,
                        startDate: tmpForecastStartDate,
                        cropType: item?.coldStressRisk,
                        endDate: tmpForecastEndDate,
                        languageCode: previewDetails?.languageCode,
                        groupIdForMixed: (item?.historicalDays || 7) + '-' + (item?.forecastDays || 7) + '-' + item?.coldStressRisk,
                        groupId: tmpForecastStartDate + '-' + tmpForecastEndDate
                    });
                    // for historical
                    const tmpHistoricalDays = item?.historicalDays || 7;
                    const tmpHistoricalStartDate = moment().add(-tmpHistoricalDays,'day').format('yyyy-MM-DD');
                    const tmpHistoricalEndDate = moment().add(-1,'day').format('yyyy-MM-DD');
                    tmpAllColdStressRiskReq.push({
                        lat: previewDetails?.templateLat,
                        lng: previewDetails?.templateLng,
                        startDate: tmpHistoricalStartDate,
                        cropType: item?.coldStressRisk,
                        endDate: tmpHistoricalEndDate,
                        languageCode: previewDetails?.languageCode,
                        groupIdForMixed: (item?.historicalDays || 7) + '-' + (item?.forecastDays || 7) + '-' + item?.coldStressRisk,
                        groupId: tmpHistoricalStartDate + '-' + tmpHistoricalEndDate
                    });
                });

            }
            if(tmpAllColdStressRiskReq?.length >= 1){
                setAllColdStressRiskReq(tmpAllColdStressRiskReq);
                setShowColdStressRisk(true);
            }
        }
        catch(error){
            console.log(error);
        }
    };

    // show child component
    const [showPlanting,setShowPlanting] = useState<boolean>(false);
    const [allPlantingReq,setAllPlantingReq] = useState<IGetPlantingReqModel[]>([]);
    const [showSpray,setShowSpray] = useState<boolean>(false);
    const [allSprayReq,setAllSprayReq] = useState<IGetCorpsSprayReqModel[]>([]);
    const [showDisease,setShowDisease] = useState<boolean>(false);
    const [allDiseaseRiskReq,setAllDiseaseRiskReq] = useState<IGetDiseaseRiskReqModel[]>([]);
    const [showStressAlert,setShowStressAlert] = useState<boolean>(false);
    const [allStressAlertReq,setAllStressAlertReq] = useState<IGetStressAlertReqModel[]>([]);
    const [showHeatStressRisk,setShowHeatStressRisk] = useState<boolean>(false);
    const [showColdStressRisk,setShowColdStressRisk] = useState<boolean>(false);
    const [allHeatStressRiskReq,setAllHeatStressRiskReq] = useState<IGetPhytophagyStressReqModel[]>([]);
    const [allColdtressRiskReq,setAllColdStressRiskReq] = useState<IGetPhytophagyStressReqModel[]>([]);

    // init the data from api
    const initFunc = async()=>{
        const tmpTranslateData = await checkWhetherGetTranslateFromApi();
        console.log('lanxue final translate',tmpTranslateData);
        console.log('lanxue preview',previewDetails);
        /**
         * for Agronomic
         * will include spray, planting, heat and disease
         */
        if(previewDetails?.isShowAgronomic){
            initAgronomic();
        }
        if(previewDetails?.isShowHistoricalChart){
            // getHistoricalDataFunc(tmpTranslateData);
        }
        if(previewDetails?.isShowForecastChart){
            // getForecastDataFunc(tmpTranslateData,'chart');
        }
        if(previewDetails?.isShowForecastTable){
            // getForecastDataFunc(tmpTranslateData,'table');
        }
        // TODO: get hourly data
        if(previewDetails?.isShowForecastTableHourly){
            // getForecastHourlyDataFunc(tmpTranslateData);
        }
        getAllBannerFromS3();
        getFinalLocationName();
        getFinalDate(previewDetails?.templateDate,'YYYY/MM/DD HH:mm:ss',tmpTranslateData);
    };
    useEffect(()=>{
        if(modalOpen){
            initFunc();
        }
        else{
            setFinalLocationName(null);
        }
    },[modalOpen]);


    const [finalLocationName,setFinalLocationName] = useState(null);

    const getFinalLocationName = ()=>{
        const tmpLocationName = previewDetails?.templateLocationName.split(',');
        let tmpFinalLocationName = null;
        if(Number(tmpLocationName[0]) || Number(tmpLocationName[0]) === 0){
            tmpFinalLocationName = previewDetails?.templateLocationName;
        }
        else{
            tmpFinalLocationName = `${previewDetails?.templateLocationName} (${previewDetails?.templateLng} , ${previewDetails?.templateLat})`;
        }
        setFinalLocationName(tmpFinalLocationName);
    };
    const [finalDisplayDate,setFinalDisplayDate] = useState('');
    const getFinalDate = (date:string,initFormat: string,translateData: IAgriAlertTranslateResModel)=>{
        const tmpDate = moment(date,initFormat);
        let tmpFinalDisplayDate = '';
        if(tmpDate.isValid){
            const monthIndex = tmpDate.month();
            let tmpMonth = '';
            switch(monthIndex){
                case 0:
                    tmpMonth = translateData?.jan_short;
                    break;
                case 1:
                    tmpMonth = translateData?.feb_short;
                    break;
                case 2:
                    tmpMonth = translateData?.mar_short;
                    break;
                case 3:
                    tmpMonth = translateData?.apr_short;
                    break;
                case 4:
                    tmpMonth = translateData?.may_short;
                    break;
                case 5:
                    tmpMonth = translateData?.jun_short;
                    break;
                case 6:
                    tmpMonth = translateData?.jul_short;
                    break;
                case 7:
                    tmpMonth = translateData?.aug_short;
                    break;
                case 8:
                    tmpMonth = translateData?.sep_short;
                    break;
                case 9:
                    tmpMonth = translateData?.oct_short;
                    break;
                case 10:
                    tmpMonth = translateData?.nov_short;
                    break;
                case 11:
                    tmpMonth = translateData?.dec_short;
                    break;
            }
            // const tmpDayForMat = tmpDate.format('DD YYYY');
            const tmpYearForMat = tmpDate.format('YYYY');
            const tmpDayForMat = tmpDate.format('DD');
            tmpMonth = `${tmpDayForMat} ${tmpMonth} ${tmpYearForMat}`;
            tmpFinalDisplayDate = tmpMonth;
        }
        else{
            tmpFinalDisplayDate = date;
        }
        setFinalDisplayDate(tmpFinalDisplayDate);
    };


    const [hasEditFooter,setHasEditFooter]=useState<boolean>(false);
    useEffect(()=>{
        if((editableFooterContent!=='')&&(editableFooterContent!==null))
        {
            setHasEditFooter(true);
        }
        else{
            setHasEditFooter(false);
        }
    },[]);

    const cancelFunc = ()=>{
        changeModalOpenCallback();
        setShowPlanting(false);
    };
    console.log('lanxue planting allPlantingReq',allPlantingReq);

    return(
        <div className='template-preview' id = 'template-preview'>
            <Modal
                className='template-preview-modal'
                open={modalOpen}
                onCancel={cancelFunc}
                width={903}
                cancelText={finalTranslateData?.close || 'Close'}
                closable = {true}
                okButtonProps={null}
                destroyOnClose = {true}
                getContainer = {()=> document.getElementById('template-preview') as HTMLElement}
                footer={[
                    <Button key="cancel" onClick={cancelFunc}>
                        {finalTranslateData?.close || 'Close'}
                    </Button>,
                ]}
            >
                <div className='template-preview-container'>
                    {/* template bacisc info */}
                    <div className="template-basic-info" style={{backgroundColor:'#0C612C'}}>
                        {/* @* template name, date and banner *@ */}
                        <div className="template-basic-name-date-banner template-basic-width">
                            <div className="template-basic-name-date">
                                <div className="template-basic-name">
                                    {previewDetails?.templateName}
                                </div>
                                <div className="template-basic-date">
                                    {/* {moment(previewDetails?.templateDate,'YYYY/MM/DD HH:mm:ss')?.format('MMMM DD YYYY')} */}
                                    {finalDisplayDate}
                                </div>
                            </div>
                            <div className='template-basic-banner-container'>
                                {
                                    allBannerUrl?.map((item,index)=>{
                                        return(
                                            <>
                                                <img
                                                    key={index + item + 'list-banner'}
                                                    className="template-bacis-banner-image"
                                                    src={item} style={{height:'50px'}} />
                                            </>
                                        );
                                    })
                                }
                                {
                                    localImageList?.map((item,index)=>{
                                        return(
                                            <>
                                                <img
                                                    key={index + item + 'local-banner'}
                                                    className="template-bacis-banner-image"
                                                    src={item} style={{height:'50px'}} />
                                            </>
                                        );
                                    })
                                }
                            </div>
                        </div>
                        {/* @* divider *@ */}
                        <div className="template-divider template-basic-width"></div>
                        {/* @* template description *@ */}
                        <div className="template-description template-basic-width">
                            <div dangerouslySetInnerHTML={{ __html: previewDetails.templateDescription }} />
                            {/* {previewDetails.templateDescription} */}
                        </div>
                        {/* @* template location information *@ */}
                        <div className="template-location-information template-basic-width">
                            <div className='template-location-informantion-box'>
                                <div className="template-location-information-title">{finalTranslateData?.location || 'Location'}</div>
                                <div className="template-location-information-name">
                                    {finalLocationName}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* content container */}
                    <div className="content-container">

                        {/* Forecast Chart */}
                        <TemplateForecastTables
                            showForecast = {previewDetails?.isShowForecastChart}
                            selectedForecastChartsOrTables={previewDetails?.forecastCharts}
                            translateValue={finalTranslateData}
                            lat={previewDetails?.templateLat}
                            lng={previewDetails?.templateLng}
                            language={previewDetails?.languageCode}
                            unit={previewDetails?.reportUnit}
                            forecastType={ChartsOrTablesEnum.CHARTS}
                        />
                        {/* <IF show={previewDetails?.isShowForecastChart}>
                            <div className="forecast-chart content-basic chart-or-table-top">
                                <div className="historical-chart-title common-title">{finalTranslateData?.forecast_chart || 'Forecast - Chart'}</div>
                                <TemplatePreviewChart
                                    id = "forecastChartRef"
                                    echartData={forecastChartData}
                                    translateData={finalTranslateData}
                                />
                            </div>

                        </IF> */}

                        {/* Forecast Table - Daily */}
                        <TemplateForecastTables
                            showForecast = {previewDetails?.isShowForecastTable}
                            selectedForecastChartsOrTables={previewDetails?.forecastTables}
                            translateValue={finalTranslateData}
                            lat={previewDetails?.templateLat}
                            lng={previewDetails?.templateLng}
                            language={previewDetails?.languageCode}
                            unit={previewDetails?.reportUnit}
                            forecastType={ChartsOrTablesEnum.TABLES}
                        />


                        {/* Disease Risk */}
                        <TemplateDisease
                            showDisease = {showDisease}
                            translateValue = {finalTranslateData}
                            languageCode = {previewDetails?.languageCode}
                            allDiseaseRiskReq = {allDiseaseRiskReq}
                        />

                        {/* Heat Stress Risk */}
                        <TemplateHeatStressRisk
                            showPhytophagyStress = {showHeatStressRisk}
                            translateValue = {finalTranslateData}
                            languageCode = {previewDetails?.languageCode}
                            allPhytophagyStressReq={allHeatStressRiskReq}
                            heatOrColdType={HeatOrColdStressRiskEnum.HEATSTRESSRISK}
                        />

                        {/* Phytophagy Stress */}
                        <TemplateColdStressRisk
                            showPhytophagyStress = {showColdStressRisk}
                            translateValue = {finalTranslateData}
                            languageCode = {previewDetails?.languageCode}
                            allPhytophagyStressReq={allColdtressRiskReq}
                            heatOrColdType={HeatOrColdStressRiskEnum.COLDSTRESSRISK}
                        />

                        {/* Planting Data */}
                        <TemplatePlanting
                            showPlanting = {showPlanting}
                            translateValue={finalTranslateData}
                            languageCode= {previewDetails?.languageCode}
                            allPlantingReq={allPlantingReq}
                        />

                        {/* @* Spray Window *@ */}
                        <TemplateSpray
                            showSpray = {showSpray}
                            translateValue={finalTranslateData}
                            languageCode= {previewDetails?.languageCode}
                            allStressAlertReq={allSprayReq}
                        />

                        {/* Stress Alert */}
                        <TemplateStress
                            showStressAlert = {showStressAlert}
                            translateValue={finalTranslateData}
                            languageCode= {previewDetails?.languageCode}
                            allStressAlertReq={allStressAlertReq}
                        />



                        {/* @* Historical Chart *@ */}
                        <TemplateHistoricalChart
                            showHistoricalChart = {previewDetails?.isShowHistoricalChart}
                            selectedHistoricalCharts={previewDetails?.historicalCharts}
                            translateValue={finalTranslateData}
                            historicalData={historicalData}
                            lat={previewDetails?.templateLat}
                            lng={previewDetails?.templateLng}
                            language={previewDetails?.languageCode}
                            unit={previewDetails?.reportUnit}
                        />
                        {/* <IF show={previewDetails?.isShowHistoricalChart}>
                            <div className="historical-chart content-basic chart-or-table-top">
                                <div className="historical-chart-title common-title">{finalTranslateData?.historical_chart || 'Historical- Chart'}</div>
                                <TemplatePreviewChart
                                    id = "historicalChartRef"
                                    echartData={historicalData}
                                    translateData={finalTranslateData}
                                />
                            </div>
                        </IF> */}
                        <div className='footer-information' >
                            <div className='mandatory-footer'>
                                <table>
                                    <tr className={hasEditFooter?'':'hide'}>
                                        <td>{editableFooterContent}</td>
                                    </tr>
                                    <tr>
                                        <td>{finalTranslateData?.footer_copyright}.</td>
                                    </tr>
                                    <tr>
                                        <td>{finalTranslateData?.footer_service}
                                            <a style={{marginLeft:'3px'}} title='https://www.meteoblue.com/' className='strong-text'
                                                href='https://www.meteoblue.com/'>{finalTranslateData?.footer_meteoblue}
                                            </a>.
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <p className='strong-text'>
                                                {finalTranslateData?.footer_data}
                                            </p>
                                            {finalTranslateData?.footer_content}.</td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <p className='strong-text'>
                                                {finalTranslateData?.footer_click_content}
                                                <a style={{margin:'0 3px'}} title='mailto:pradeep.kethireddy@syngenta.com?subject=Remove my email-id from the report'
                                                    href='mailto:pradeep.kethireddy@syngenta.com?subject=Remove my email-id from the report'>
                                                    {finalTranslateData?.footer_here}
                                                </a>
                                                {finalTranslateData?.footer_unsubscribe}.
                                            </p>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    );

};

export default React.memo(TemplatePreview);